<div class="overlay-container" [class.is-hidden]="!isShown"></div>
